import { AuthGuard } from './autentificacion/guard/auth.guard';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
const ɵ0 = () => import("./dashboard/dashboard.module.ngfactory").then(m => m.DashboardModuleNgFactory), ɵ1 = () => import("./administracion/administracion.module.ngfactory").then(m => m.AdministracionModuleNgFactory), ɵ2 = () => import("./administracion-eventos/abm-categorias/categoria.module.ngfactory").then(m => m.CategoriaModuleNgFactory), ɵ3 = () => import("./administracion-usuarios/administracion-usuarios.module.ngfactory").then(m => m.AdministracionUsuariosModuleNgFactory), ɵ4 = () => import("./administracion-entradas/generador-tickets/generador-tickets.module.ngfactory").then(m => m.GeneradorTicketsModuleNgFactory), ɵ5 = () => import("./administracion-escenarios/administracion-escenario.module.ngfactory").then(m => m.AdministracionEscenarioModuleNgFactory), ɵ6 = () => import("./administracion/punto-de-venta/punto-de-venta.module.ngfactory").then(m => m.PuntoDeVentaModuleNgFactory), ɵ7 = () => import("./administracion/reporte-pagofacil-diario/reporte-pagofacil-diario.module.ngfactory").then(m => m.ReportePagofacilDiarioModuleNgFactory), ɵ8 = () => import("./administracion-eventos/abm-eventos/abmeventos.module.ngfactory").then(m => m.ABMEventosModuleNgFactory), ɵ9 = () => import("./administracion-eventos/abm-eventos/abm-funciones-sectores/abm-funciones-sectores.module.ngfactory").then(m => m.ABMFuncionesSectoresRoutesModuleNgFactory), ɵ10 = () => import("./administracion-entradas/generador-credenciales/generador-credenciales.module.ngfactory").then(m => m.GeneradorCredencialesModuleNgFactory), ɵ11 = () => import("./administracion-entradas/generador-credenciales-ticket-big/generador-credenciales-ticket-big.module.ngfactory").then(m => m.GeneradorCredencialesTicketBigModuleNgFactory), ɵ12 = () => import("./reserva-mercado-pago/reserva-mercado-pago.module.ngfactory").then(m => m.ReservaMercadoPagoModuleNgFactory), ɵ13 = () => import("./puntoventa-por-evento/puntoventa-por-evento.module.ngfactory").then(m => m.PuntoventaPorEventoModuleNgFactory), ɵ14 = () => import("./sincronizacion-molinete/sincronizacion-molinete.module.ngfactory").then(m => m.SincronizacionMolineteModuleNgFactory), ɵ15 = () => import("./configurations-scanner/configurations-scanner.module.ngfactory").then(m => m.ConfigurationsScannerModuleNgFactory), ɵ16 = () => import("./administracion-boleterias/abm-boleteria/abm-boleteria.module.ngfactory").then(m => m.AbmBoleteriaModuleNgFactory), ɵ17 = () => import("./administracion-rrpp/abm-rrpp/abm-rrpp.module.ngfactory").then(m => m.AbmRrppModuleNgFactory), ɵ18 = () => import("./error/error.module.ngfactory").then(m => m.ErrorModuleNgFactory), ɵ19 = () => import("./autentificacion/autentificacion.module.ngfactory").then(m => m.AutentificacionModuleNgFactory);
export const AppRoutes = [
    {
        path: '',
        component: AdminLayoutComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: 'home',
                loadChildren: ɵ0
            },
            {
                path: 'administracion',
                loadChildren: ɵ1
            },
            {
                path: 'categorias',
                loadChildren: ɵ2
            },
            {
                path: 'usuarios',
                loadChildren: ɵ3
            },
            {
                path: 'generador-entradas',
                loadChildren: ɵ4
            },
            {
                path: 'administracion-escenarios',
                loadChildren: ɵ5
            },
            {
                path: 'puntoDeVenta',
                loadChildren: ɵ6
            },
            {
                path: 'reportePagoFacil',
                loadChildren: ɵ7
            },
            {
                path: 'abm-evento',
                loadChildren: ɵ8
            },
            {
                path: 'abm-funciones-sectores',
                loadChildren: ɵ9
            },
            {
                path: 'generador-credenciales',
                loadChildren: ɵ10
            },
            {
                path: 'generador-credenciales-ticket-big',
                loadChildren: ɵ11
            },
            {
                path: 'reserva-mercado-pago',
                loadChildren: ɵ12
            },
            {
                path: 'puntoventa-por-evento',
                loadChildren: ɵ13
            },
            {
                path: 'sincronizacion-molinete',
                loadChildren: ɵ14
            },
            {
                path: 'configurations-scanner',
                loadChildren: ɵ15
            },
            {
                path: 'abm-boleteria',
                loadChildren: ɵ16
            },
            {
                path: 'abm-rrpp',
                loadChildren: ɵ17
            },
        ]
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            {
                path: 'error',
                loadChildren: ɵ18
            },
            {
                path: 'autentificacion',
                loadChildren: ɵ19
            }
        ]
    },
    { path: '**', redirectTo: 'session/404' }
];
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19 };
